export default "__VITE_ASSET__14ba0ef1__"